import { SelectPicker } from 'rsuite';
import { ButtonPrimary, Callout } from '../../../../../components';
import { AssignmentList, AssignmentModal, LevelChangeModal, RemoveAssignmentModal } from './components';
import { usePricingScopeController } from './hooks';
import styles from './SetupIpaPricingResponsibilities.module.scss';

export const SetupIpaPricingResponsibilities = () => {
  const controller = usePricingScopeController();
  const { data, state, loading, handlers } = controller;
  const keepAssignmentsCardMounted = state.search.length > 0 || state.isClearingSearch;

  return (
    <div className={styles.root}>
      <section className={styles.card}>
        <header className={styles.header}>
          <h2 className={styles.title}>Responsáveis pela precificação</h2>
          <p className={styles.description}>
            Configure os responsáveis pela precificação e suas categorias. Esta configuração alimenta o filtro Responsável pela precificação disponível em
            outras telas do IPA.
          </p>
        </header>
      </section>

      <section className={`${styles.card} ${styles['category-level-card']}`}>
        <header className={styles.header}>
          <h2 className={styles.title}>Nível de categoria dos responsáveis pela precificação</h2>
          <p className={styles.description}>
            Nível da árvore de categorias usado para vincular responsáveis pela precificação aos produtos. Ao trocar o nível, as atribuições existentes são
            removidas.
          </p>
        </header>

        <SelectPicker
          aria-label="Nível de categoria dos responsáveis pela precificação"
          className={styles['category-level-select']}
          cleanable={false}
          data={data.levelOptions}
          loading={loading.categoryLevels}
          placeholder="Selecione um nível de categoria"
          searchable={false}
          value={data.currentLevel?.level ?? null}
          onChange={value => handlers.handleLevelChange(value ?? null)}
        />
      </section>

      {data.currentLevel && data.assignmentsPage && !loading.savingLevel && (!loading.assignments || keepAssignmentsCardMounted) && (
        <section className={`${styles.card} ${styles['assignments-card']}`}>
          <header className={styles['assignments-header']}>
            <div className={styles.header}>
              <h2 className={styles.title}>Atribuições</h2>
              <p className={styles.description}>
                Responsáveis pela precificação e suas categorias. Uma categoria pode ser compartilhada entre mais de um responsável pela precificação.
              </p>
            </div>
            <ButtonPrimary size="medium" type="button" onClick={handlers.openCreateAssignment}>
              nova atribuição
            </ButtonPrimary>
          </header>

          {(loading.assignments || (data.assignmentsPage?.totalElements ?? 0) > 0 || !!state.search) && (
            <AssignmentList
              assignments={data.assignments}
              page={data.assignmentsPage}
              search={state.search}
              loading={loading.assignments}
              onSearch={handlers.handleSearch}
              onChangePage={handlers.setPage}
              onEdit={handlers.openEditAssignment}
              onRemove={handlers.setAssignmentToRemove}
            />
          )}
        </section>
      )}

      <section className={styles.card}>
        <Callout className={styles.warning} variant="warning" size="sm">
          As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
        </Callout>
      </section>

      <LevelChangeModal
        level={state.pendingLevel}
        assignmentCount={data.assignmentCount ?? 0}
        loading={loading.savingLevel}
        onCancel={handlers.cancelLevelChange}
        onConfirm={handlers.confirmLevelChange}
      />

      {state.assignmentModal && data.currentLevel && (
        <AssignmentModal
          state={state.assignmentModal}
          level={data.currentLevel}
          loading={loading.savingAssignment}
          onClose={handlers.closeAssignmentModal}
          onSubmit={handlers.saveAssignment}
          onEditExisting={handlers.editExistingAssignmentForUser}
        />
      )}

      <RemoveAssignmentModal
        assignment={state.assignmentToRemove}
        loading={loading.removingAssignment}
        onCancel={() => handlers.setAssignmentToRemove(null)}
        onConfirm={handlers.removeAssignment}
      />
    </div>
  );
};
